import Vue from 'vue';
import Echo from 'laravel-echo';
import { captureException } from "@sentry/vue";

import authService from './services/AuthService';
import profileService from './services/ProfileService';

window.Pusher = require('pusher-js');

const PUSHER_APP_KEY = 'jxaike2BiNJVuQjg';
// const PUSHER_APP_ID = 'LyySdCKTH3Fej5tq';
// const PUSHER_APP_SECRET = 'Coeta4PO1H9jWDDs';

export var echo_instance = new Echo({
  broadcaster: 'pusher',
  key: PUSHER_APP_KEY,
  wsHost: 'topmenumarket.com',
  authEndpoint: 'https://topmenumarket.com/broadcasting/auth',
  encrypted: true,
  forceTLS: true,
  wsPort: 6001,
  wssPort: 6001,
  disableStats: false,
  enabledTransports: ['ws', 'wss'],
  auth: {
    headers: {
      authorization: 'Bearer ' + authService.token,
    }
  }
}).private(`user-${authService.id}`)
  .error((error) => {
    captureException({
      errorMessage: error?.error,
      userId: `user-${authService.id}`,
      providerId: profileService.selectedProvider
    });
  });

Vue.prototype.$echo = echo_instance;

export default Vue;